import React from 'react';
import RangeSlider from 'react-range-slider-input';
import './RangeFilter.css'; // подключаем кастомизацию

type Props = {
	// Значения для слайдера (0-based индексы)
	sliderValue: [number, number];
	// Значения для отображения в инпутах (1-based дни)
	displayValue: [number, number];
	// Обработчик изменения (получает 0-based индексы)
	onChange: (value: [number, number]) => void;
	// Максимальное значение для слайдера (количество дней - 1)
	maxValue: number;
	// Максимальное значение для отображения (количество дней)
	maxDisplayValue: number;
};

const MonthRangeFilter: React.FC<Props> = ({
	sliderValue,
	displayValue,
	onChange,
	maxValue,
	maxDisplayValue,
}) => {
	const handleInput = (value: [number, number]) => {
		onChange(value);
	};

	const handleChangeRangeByInput = (
		currentTarget: {value: string},
		type: string,
	) => {
		const inputValue = +currentTarget.value;
		// Проверяем, что значение в допустимом диапазоне для дней (1..maxDisplayValue)
		if (inputValue >= 1 && inputValue <= maxDisplayValue) {
			// Преобразуем день в индекс для слайдера (день - 1)
			const indexValue = inputValue - 1;
			if (type === 'min') {
				onChange([
					indexValue,
					sliderValue[1],
				]);
			} else if (type === 'max') {
				onChange([
					sliderValue[0],
					indexValue,
				]);
			}
		}
	};

	return (
		<div className="range-filter">
			<div className="range-filter__values values-range-filter">
				<div className="values-range-filter__column">
					<div className="values-range-filter__input">
						<input
							id="active_points_from"
							placeholder="1"
							autoComplete="off"
							value={displayValue[0]}
							onChange={({currentTarget}) =>
								handleChangeRangeByInput(currentTarget, 'min')
							}
							name="active_points_from"
							className="input"
							min={1}
							max={maxDisplayValue}
						/>
					</div>
				</div>
				<div className="values-range-filter__spaceContainer">
					<div className="values-range-filter__space" />
				</div>
				<div className="values-range-filter__column">
					<div className="values-range-filter__input">
						<input
							id="active_points_to"
							placeholder={maxDisplayValue.toString()}
							autoComplete="off"
							name="active_points_to"
							className="input"
							onChange={({currentTarget}) =>
								handleChangeRangeByInput(currentTarget, 'max')
							}
							value={displayValue[1]}
							min={displayValue[0]}
							max={maxDisplayValue}
						/>
					</div>
				</div>
			</div>

			<div>
				<RangeSlider 
					value={sliderValue} 
					id="range-slider" 
					onInput={handleInput} 
					min={0} 
					max={maxValue}
				/>
			</div>
		</div>
	);
};

export default MonthRangeFilter;

